export default __webpack_public_path__ + "static/media/ulises_login.817cf652.png";